/**
 * Cliente API del wizard de onboarding (Sprint 18 P2).
 */
import { apiFetch } from './client';

export interface WizardFinalizarResponse {
  lote_id: string;
  wizard_completado: boolean;
}

/** Marca el onboarding como completado (paso final) + acepta la política
 * de datos (Ley 21.719). Idempotente. */
export function finalizarWizard(
  loteId: string,
): Promise<WizardFinalizarResponse> {
  return apiFetch<WizardFinalizarResponse>('/me/wizard/finalizar', {
    method: 'POST',
    body: JSON.stringify({ lote_id: loteId }),
  });
}

export interface ConsentimientoResponse {
  consentimiento_ley21719_at: string | null;
}

/** Sella el consentimiento Ley 21.719 al aceptar la política de datos
 * (paso 1 del wizard). Idempotente: si ya consintió, devuelve la fecha
 * existente sin cambios (D-P25-B). */
export function registrarConsentimiento(): Promise<ConsentimientoResponse> {
  return apiFetch<ConsentimientoResponse>('/me/consentimiento', {
    method: 'POST',
  });
}
